import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList'; // @ts-expect-error module is untyped

import MainSection from 'ecosystem-marketplace-core/components/layout/MainSection'; // @ts-expect-error module is untyped

import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import RouterNavButton, { ActiveDropdownButton, DropdownButton, LegacyNavButton } from './RouterNavButton'; // @ts-expect-error module is untyped

import { useEmbedContext } from '../../../hooks/useEmbedContext';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';
import { getIsPublicApp } from '../../../selectors/app';
import { selectDisplayedCollections, selectCollectionSlugs } from '../../../slices/collections/collectionsSlice';
export default function DesktopBrowseBar() {
  const {
    isEmbedded
  } = useEmbedContext();
  const isPrerender = getIsPrerenderUserAgent();
  const isPublicApp = useSelector(getIsPublicApp);
  const collections = useSelector(selectDisplayedCollections);
  const collectionSlugs = useSelector(selectCollectionSlugs);
  const activeCollectionRoutes = collectionSlugs.concat(['/']);
  const isActiveCollectionRoute = useIsActiveRoute({
    pathname: activeCollectionRoutes
  }, true);
  return /*#__PURE__*/_jsx(MainSection, {
    className: "p-y-3",
    color: "light",
    children: /*#__PURE__*/_jsx(MainSectionInner, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        justify: "center",
        children: [/*#__PURE__*/_jsx(UIDropdown, {
          Button: isActiveCollectionRoute ? ActiveDropdownButton : DropdownButton,
          buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.nav.discover"
          }),
          "data-test-id": "storefront-nav-discover-dropdown",
          defaultOpen: isPrerender,
          children: /*#__PURE__*/_jsxs(UIList, {
            children: [/*#__PURE__*/_jsx(RouterNavButton, {
              to: "/",
              exact: true,
              "data-test-id": "storefront-nav-collection-button::all",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.nav.allCollections"
              })
            }), collections.map(({
              id,
              slug
            }) => {
              return /*#__PURE__*/_jsx(RouterNavButton, {
                to: `/${slug}`,
                exact: true,
                "data-test-id": `storefront-nav-collection-button::${slug}`,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `marketplace-assets-ui.collections.collection_${id}.title`
                })
              }, id);
            })]
          })
        }), /*#__PURE__*/_jsx(RouterNavButton, {
          active: !isActiveCollectionRoute,
          "data-test-id": "storefront-nav-themes-button",
          to: "/all",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.nav.themes"
          })
        }), !(isEmbedded || isPublicApp) && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(LegacyNavButton, {
            "data-test-id": "storefront-nav-modules-button",
            goodSubType: "CUSTOM_MODULE",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.modules"
            })
          }), /*#__PURE__*/_jsx(LegacyNavButton, {
            "data-test-id": "storefront-nav-templates-button",
            goodSubType: "TEMPLATES",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.templates"
            })
          })]
        })]
      })
    })
  });
}